module.exports = __webpack_public_path__ + "static/Mateusz_2-4b4c5fe7e16e76e4765d15861b4cda3d.jpg";